import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Standard} from '../../../../../models/standard.model';
import {Question} from '../../../../../models/question.model';
import {Answer} from '../../../../../models/answer.model';
import {AdminService} from '../../../../../services/admin.service';
import {Response} from '@angular/http';

@Component({
  selector: 'app-edit-question',
  templateUrl: './edit-question.component.html',
  styleUrls: ['./edit-question.component.css']
})
export class EditQuestionComponent implements OnInit {
  standard: Standard;
  tmpStandard: any = null;
  questionLang: string;
  newQuestion: any;
  oldQuestion: Question;
  successInfo = false;
  invalidQuestions = false;
  isLoaded = true;
  errorMessage = false;

  constructor(public activeModal: NgbActiveModal,
              private adminService: AdminService) {
  }

  ngOnInit() {

  }

  initParams(standard: Standard, question: Question, lang: string, tmpStandard: any = null) {
    this.standard = standard;
    this.tmpStandard = tmpStandard;
    this.oldQuestion = question;
    this.newQuestion = {
      isTesting: question.isTesting,
      answers: JSON.parse(JSON.stringify(question.answers)),
      questionText: question.questionText,
      rightAnswer: this.selectIndexOfCorrectAnswer(question),
    };
    this.questionLang = lang;
  }

  saveQuestion() {
    this.invalidQuestions = false;
    this.isLoaded = false;
    if (this.isQuestionsValid()) {
      this.successInfo = false;
      const editedQuestion = this.setCorrectAnswer(this.newQuestion);
      const combinedQuestion = this.combineQuestions(this.oldQuestion, editedQuestion);
      this.switchEditQuestion(combinedQuestion, editedQuestion);
    } else {
      this.invalidQuestions = true;
      this.isLoaded = true;
      this.successInfo = false;
    }
  }

  switchEditQuestion(combinedQuestion: any, editedQuestion: Question) {
    if (this.tmpStandard !== null) {
      switch (this.questionLang.toUpperCase()) {
        case 'RUSSIAN': {
          const index = this.tmpStandard.questions.russian.indexOf(this.oldQuestion);
          if (index !== -1) {
            this.tmpStandard.questions.russian[index] = editedQuestion;
            this.replacePairedQuestion('english', index, editedQuestion);
          }
          break;
        }
        case 'ENGLISH': {
          const index = this.tmpStandard.questions.english.indexOf(this.oldQuestion);
          if (index !== -1) {
            this.tmpStandard.questions.english[index] = editedQuestion;
            this.replacePairedQuestion('russian', index, editedQuestion);
          }
          break;
        }
      }
      this.errorMessage = false;
      this.successInfo = true;
      this.isLoaded = true;
      this.ngOnInit();
    } else {
      this.adminService.editQuestionInStandard(combinedQuestion, this.standard.id, this.questionLang).subscribe(
      (response) => {
          if (response.status === 200) {
            this.errorMessage = false;
            this.updateQuestion(editedQuestion);
            this.successInfo = true;
            this.isLoaded = true;
          }
        }, (error) => {
          this.isLoaded = true;
          this.errorMessage = true;


        }
      );
    }
  }

  private replacePairedQuestion(languageKey: string, index: number, editedQuestion: Question) {
    if (!this.tmpStandard.questions[languageKey] || this.tmpStandard.questions[languageKey].length <= index) {
      return;
    }
    this.tmpStandard.questions[languageKey][index] = JSON.parse(JSON.stringify(editedQuestion));
  }

  private updateQuestion(editedQuestion: Question) {
    this.oldQuestion.answers = editedQuestion.answers;
    this.oldQuestion.questionText = editedQuestion.questionText;
    this.oldQuestion.rightAnswer.answerText = editedQuestion.rightAnswer.answerText;
  }

  private combineQuestions(oldQuestion: Question, newQuestion: Question) {
    return {
      currentQuestionText: oldQuestion.questionText,
      currentAnswers: oldQuestion.answers,
      currentRightAnswer: oldQuestion.rightAnswer,
      newQuestionText: newQuestion.questionText,
      newAnswers: newQuestion.answers,
      newRightAnswer: newQuestion.rightAnswer
    };
  }

  private setCorrectAnswer(question: any) {
    return new Question(
      question.answers,
      question.isTesting,
      question.questionText,
      question.answers[Number.parseInt(question.rightAnswer) - 1]
    );
  }

  private selectIndexOfCorrectAnswer(question: Question) {
    return question.answers.findIndex(item => 
      item.answerText === question.rightAnswer.answerText
      ) + 1;
  }

  public validateCorrectAnswer(event: any) {
    event.target.value = event.target.value.length > 1
      ? event.target.value[0]
      : event.target.value.replace(/\b/, '');
  }

  private isQuestionsValid() {
    if (this.newQuestion.questionText === ''
      || this.newQuestion.rightAnswer < 1
        || this.newQuestion.rightAnswer > 3) {
      return false;
    }

    if (this.newQuestion.answers[0].answerText === ''
      || this.newQuestion.answers[1].answerText === ''
      || this.newQuestion.answers[2].answerText === '') {
      return false;
    }

    const answersSet = new Set();
    answersSet.add(this.newQuestion.answers[0].answerText);
    answersSet.add(this.newQuestion.answers[1].answerText);
    answersSet.add(this.newQuestion.answers[2].answerText);
    if (answersSet.size < this.newQuestion.answers.length) {
      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/create-operating-standard/opst-step-eight/edit-question-step-popup/edit-question.component.ts